import { render, staticRenderFns } from "./statistical-analysis-skeleton-dossier-navigation-items.vue?vue&type=template&id=5438aa42&scoped=true&"
import script from "./statistical-analysis-skeleton-dossier-navigation-items.ts?vue&type=script&lang=ts&"
export * from "./statistical-analysis-skeleton-dossier-navigation-items.ts?vue&type=script&lang=ts&"
import style0 from "./statistical-analysis-skeleton-dossier-navigation-items.scss?vue&type=style&index=0&id=5438aa42&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5438aa42",
  null
  
)

export default component.exports